var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOkchain = function SvgOkchain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2 18H18.8C18.3582 18 18 18.3582 18 18.8V29.2C18 29.6418 18.3582 30 18.8 30H29.2C29.6418 30 30 29.6418 30 29.2V18.8C30 18.3582 29.6418 18 29.2 18ZM41.2052 30H30.8052C30.3633 30 30.0051 30.3582 30.0051 30.8V41.2C30.0051 41.6418 30.3633 41.9999 30.8052 41.9999H41.2052C41.647 41.9999 42.0051 41.6418 42.0051 41.2V30.8C42.0051 30.3582 41.647 30 41.2052 30ZM42.8 18H53.2C53.6418 18 54 18.3582 54 18.8V29.2C54 29.6418 53.6418 30 53.2 30H42.8C42.3582 30 42 29.6418 42 29.2V18.8C42 18.3582 42.3582 18 42.8 18ZM29.2 42H18.8C18.3582 42 18 42.3582 18 42.8V53.2C18 53.6418 18.3582 54 18.8 54H29.2C29.6418 54 30 53.6418 30 53.2V42.8C30 42.3582 29.6418 42 29.2 42ZM42.8 42H53.2C53.6418 42 54 42.3582 54 42.8V53.2C54 53.6418 53.6418 54 53.2 54H42.8C42.3582 54 42 53.6418 42 53.2V42.8C42 42.3582 42.3582 42 42.8 42Z",
    fill: "white"
  })));
};

export { SvgOkchain as ReactComponent };
export default __webpack_public_path__ + "0c9392ac7c7581f8283b9feddcaa23a7.svg";